import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// import { WhyUsComponent } from '../why-us/why-us.component';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.less']
})
export class BannerComponent implements OnInit {

  headingBanner: string
  subCaptionBanner: string

  constructor(private router: Router) {
    this.headingBanner = "Tailoring | Alterations | Wedding Blouse & Sarees | AARI Works";
    this.subCaptionBanner = "A MORDERN BOUTIQUE WITH VINTAGE CHARM.";

  }

  ngOnInit() {

  }
  goToTargetComponent() {
    this.router.navigate(['/why-us']);
  }

}
